import type { ChapterItem } from '@app/_proto/Protos/chapters';
import { createContext, useContext } from 'react';

export const CurrentChapterContext = createContext<ChapterItem | undefined>(undefined);

export const useCurrentChapter = () => useContext(CurrentChapterContext);
